import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const TransplantCharacteristicService = {
    LoadData,
    SaveData
};
function LoadData(pid) {
    return WebServiceWrapper.Get(`/transplantCharacteristic/LoadTransplantData?patientId=${pid}&isAdmin=${IsAdmin()}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/transplantCharacteristic/SaveTransplantData", payload);
}
